import { render, staticRenderFns } from "./UploadLoader.vue?vue&type=template&id=c86d7226&scoped=true&"
import script from "./UploadLoader.vue?vue&type=script&lang=js&"
export * from "./UploadLoader.vue?vue&type=script&lang=js&"
import style0 from "./UploadLoader.vue?vue&type=style&index=0&id=c86d7226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86d7226",
  null
  
)

export default component.exports